export const orderImageForGallery = (images: string[], startImageIndex: number): string[] => {
  const orderedImages = [];
  for (let i = startImageIndex; i < images.length; i++) {
    orderedImages.push(images[i]);
  }
  for (let i = 0; i < startImageIndex; i++) {
    orderedImages.push(images[i]);
  }
  return orderedImages;
};